/**
 * Groupes de confusion pour FlagNerdTricky.
 * Intègre désormais 100 % des pays de la base de données.
 */
const GROUPS = [
	// --- RESSEMBLANCES VISUELLES (GRAPHISMES & COULEURS) ----------------

	// Mega-pool Rouge / Blanc (Bicolores, disques, croix ou bandes minimales)
	["mc", "id", "pl", "sg", "mt", "ch", "to", "ge", "ca", "pe", "at", "lv"],

	// Tricolores verticaux classiques (Fusions des grands blocs à bandes verticales)
	["fr", "it", "ie", "ci", "be", "td", "ro", "ad", "md", "ml", "gn", "cm"],

	// Miroirs et déclinaisons spécifiques : Vert-Blanc-Orange / Inde / Niger
	["ie", "ci", "in", "ne"],

	// Mega-pool Rouge-Blanc-Bleu horizontal (Pays-Bas, Russie, bloc Panslave...)
	["nl", "lu", "py", "ru", "si", "sk", "rs", "hr", "fr"],

	// Tricolore horizontal Jaune-Bleu-Rouge (Grande Colombie)
	["co", "ec", "ve"],

	// Bloc Panafricain Vertical & variantes asymétriques
	["ml", "gn", "sn", "cm", "bj", "cg", "pt", "mg", "by"],

	// Bloc Panafricain Horizontal & variantes à étoiles
	["bo", "gh", "lt", "et", "mm", "tg", "st", "sn", "bj"],

	// Bloc Panarabe étendu & Moyen-Orient (Bandes horizontales et triangles)
	["ye", "eg", "sy", "iq", "sd", "kw", "jo", "ae", "ly", "om", "sa"],

	// Croix scandinave & Structures à croix géométriques
	["no", "dk", "se", "fi", "is", "ge", "ch"],

	// Bloc Vert-Blanc-Rouge / Rouge-Blanc-Vert (Horizontaux et Verticaux mêlés)
	["it", "mx", "hu", "bg", "ir", "tj", "mg", "om", "by", "sr"],

	// Systèmes à bandes multiples + Canton ou Quadrants étoilés (Style USA / Amériques)
	["us", "my", "lr", "cl", "gr", "uy", "ws", "pa", "cu", "kp"],

	// Le Piège de l'Union Jack (Hémisphère sud et colonies)
	["au", "nz", "fj", "tv", "gb"],

	// Dominante Bleu Ciel & Blanc (Bandes horizontales, soleils ou bleu tendre)
	["ar", "uy", "sv", "ni", "hn", "gt", "il", "cy", "sm"],

	// Structures à bandes "encadrées" (Bande centrale de couleur, bords d'une autre)
	["pe", "ca", "at", "lv", "lb", "es", "la", "mn", "kh"],

	// Les dents de scie et coupures géométriques nettes
	["qa", "bh"],

	// Symboles islamiques & Étoiles/Croissants (Fonds Rouge, Vert ou Bleu)
	["tr", "tn", "pk", "dz", "mr", "sa", "az", "uz", "km", "ly"],

	// Fond rouge uni + Emblème central contrasté (Aigles, Étoiles, Soleils, Blasons)
	["al", "me", "cn", "vn", "ma", "kg", "mk", "lk", "kh"],

	// Géométrie : Triangle/Chevron net à gauche + Bandes horizontales
	["cz", "ph", "bs", "gq", "cu", "sd", "ss", "jo", "kw", "ae", "dj", "tl", "st"],

	// Géométrie complexe à gauche : Chevrons, Y, grands triangles (Style Africain / Pacifique)
	["za", "zw", "mz", "vu", "er", "gq", "bs", "jm"],

	// Lignes diagonales fortes / Drapeaux coupés en biais ou en losange
	["cg", "cd", "tz", "na", "sb", "tt", "vu", "bt", "bn", "jm", "gd"],

	// Structures complexes à 5 bandes horizontales ou plus (Rayures denses)
	["cr", "th", "kp", "la", "sr", "sz", "ug"],

	// Bicolores horizontaux/verticaux foncés avec blason ou emblème central massif
	["li", "ht", "ao", "bz", "pt", "kh"],

	// Focus géométrique : Disque ou cercle central sur fond uni, rayé ou bicolore
	["bd", "jp", "pw", "la", "ne", "in", "tn", "kr", "ug", "ki"],

	// Constellations & Étoiles sur fond bleu océan / Ciel nocturne
	["so", "fm", "mh", "nr", "cv", "sb", "nz", "au"],

	// Bandes horizontales sombres ou denses (Noir-Rouge-Vert / Multicolores sombres)
	["ke", "ss", "mw", "af", "ug", "sz", "ao"],

	// NOUVEAU : Tricolores horizontaux atypiques (Mélanges de Bleu, Vert, Noir, Orange, Blanc)
	["am", "ee", "sl", "ga", "ls", "rw", "uz", "az"],

	// NOUVEAU : Multi-rayures éclatantes (4 couleurs ou plus / Styles "arcs-en-ciel")
	["km", "cf", "mu", "sc", "za", "sz", "gr"],

	// NOUVEAU : Soleils levants, vagues et rayons géométriques
	["ag", "ki", "sc", "mk", "kz", "ar", "uy"],

	// NOUVEAU : Duo Chromatique Bleu & Jaune / Bleu & Or
	["ua", "se", "kz", "ba", "bb", "pw", "rw"],

	// Noir-Jaune-Rouge (Identités chromatiques fortes et exclusives)
	["be", "de", "ao", "ug", "sz"],


	// --- RESSEMBLANCES DE NOMS (PIÈGES PHONÉTIQUES ET TEXTUELS) ---------

	["gn", "gw", "gq", "pg"], // Les Guinée
	["ne", "ng", "np"],       // Niger / Nigeria / Népal
	["dm", "do"],             // Dominique / Rep. Dominicaine
	["at", "au"],             // Autriche / Australie
	["ml", "mw", "my", "mv", "mt"], // Le bloc des "M"
	["ir", "iq"],             // Iran / Irak
	["mr", "mu", "ma", "mg"], // Mauritanie / Maurice / Maroc / Madagascar
	["kp", "kr"],             // Les Corées
	["kn", "lc", "vc", "sm"], // Les "Saint" et îles proches
	["gm", "zm", "zw"],       // Gambie / Zambie / Zimbabwe
	["bf", "bi", "bj", "bw"], // Bloc sub-saharien en "B"
	["sd", "ss"],             // Les Soudan
	["sk", "si"],             // Slovaquie / Slovénie
	["af", "kz", "kg", "pk", "tj", "tm", "uz"], // Le bloc des "Stan"
	["gy", "gh", "ga"],       // Phonétiques en "G"
	["cg", "cd"],             // Les Congo
	["br", "bn", "bj", "bt"]  // Brésil / Brunéi / Bénin / Bhoutan
];

export function getConfusionPool(code) {
	const codes = new Set();
	GROUPS.forEach(group => {
		if (group.includes(code)) {
			group.forEach(c => {
				if (c !== code) codes.add(c);
			});
		}
	});
	return codes;
}
